// src/Components/ReservationCancelModal/ReservationCancelModal.js
import React from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';
import { Toast } from "primereact/toast";

// Actions
import * as AppActions from '../../Store/Actions/App';
import * as OrderActions from '../../Store/Actions/Order';

// Motivos (ajuste os IDs/labels conforme catálogo do backend)
// 2 - Alteração em voos ou transporte | 3 - Erro na reserva | 4 - Há outra reserva para hotel diferente | 5 - Encontrei preço melhor | 6 - Cliente desistiu da Viagem | 7 - Outros
const CANCEL_REASONS = [
  { label: 'Alteração em voos ou transporte', value: 2 },
  { label: 'Erro na reserva', value: 3 },
  { label: 'Há outra reserva para hotel diferente', value: 4 },
  { label: 'Encontrei preço melhor', value: 5 },
  { label: 'Cliente desistiu da Viagem', value: 6 },
  { label: 'Outros', value: 7 }
];


const MAX_DESC = 250;

const ReservationCancelModal = (props) => {

  const {
    cancelDialog,
    setCancelDialog,
    // dados do pai (ReservationModal.js)
    selectedReservation,
    reservationData,          // dados da resserva
    bookingId,                 // opcional: pode passar diretamente
    onReloadData,              // opcional: callback do pai p/ recarregar a lista/detalhe
    onReloadDataList,          // opcional: callback do pai p/ recarregar a lista/detalhe
    retrieveReservation,       // fallback (já existe no ReservationModal.js)
    executeRetrieveOrder,      // fallback (já existe no ReservationModal.js)
    setAlert,              // opcional: pode passar o setAlert do pai
    setAlertTitle,         // opcional: pode passar o setAlertTitle do pai
    setAlertBody,          // opcional: pode passar o setAlertBody do pai
    // actions
    cancelReservation,
  } = props;

  const isOpen = cancelDialog;

    const id =
    selectedReservation?.reservationId ||
    bookingId;

  // console.log('[reservationData]--------->]'+JSON.stringify(reservationData, null, 2));

  const [reasonId, setReasonId] = React.useState(null);
  const [description, setDescription] = React.useState('');
  const [accepted, setAccepted] = React.useState(false);
  const [submitting, setSubmitting] = React.useState(false);

  const usedChars = description.length;
  
  // useRef 
  const toast = React.useRef(null);
  

// -------------------- Cancel Info (dinâmico) --------------------
const endOfDay = (yyyy_mm_dd) => {
  if (!yyyy_mm_dd) return null;
  // força HH:MM:SS para 23:59:59 local
  const d = new Date(`${yyyy_mm_dd}T23:59:59`);
  return isNaN(d.getTime()) ? null : d;
};

const pickDeadlineISO = (rd) => {
  // Prioridade: booking.deadlines.freeCancelDate -> providerFreeCancelDate.iso -> firstRoom.cancelPolicy.until
  const a = rd?.booking?.deadlines?.freeCancelDate || null;
  const b = rd?.booking?.deadlines?.providerFreeCancelDate?.iso || null;
  const c = rd?.hotel?.rooms?.[0]?.cancelPolicy?.until || null;
  return a || b || c || null; // strings "YYYY-MM-DD"
};

const hasPaymentConfirmed = (rd) => {
  // usa latestPayment.status ou qualquer pagamento confirmado
  if (Number(rd?.latestPayment?.status) === 1) return true;
  if (Array.isArray(rd?.payments)) {
    return rd.payments.some(p =>
      Number(p?.Payment?.status) === 1 || Number(p?.status) === 1
    );
  }
  return false;
};

const wasCommissionAdvanced = (rd) => {
  // usa commission.advanceCommission ou qualquer Payment.advanceCommission
  if (!!rd?.commission?.advanceCommission) return true;
  if (Array.isArray(rd?.payments)) {
    return rd.payments.some(p => !!p?.Payment?.advanceCommission || !!p?.advanceCommission);
  }
  return false;
};

// Deriva flags
const now = new Date();
const deadlineISO = pickDeadlineISO(reservationData);
const deadlineEOD = endOfDay(deadlineISO);
const beforeDeadline = !!(deadlineEOD && now.getTime() <= deadlineEOD.getTime());
const paid = hasPaymentConfirmed(reservationData);
const advanceComm = wasCommissionAdvanced(reservationData);
const comissionStatus = reservationData?.commission?.status || null;

// Monta mensagens dinâmicas
const baseBullets = [
  'O cancelamento é irreversível e não pode ser desfeito.',
  'Um email de confirmação de cancelamento será enviado para o email do seu usuário.'
];

const dynamicBullets = (() => {
  // Sem deadline conhecida: preserve regra de reembolso apenas pelo pagamento
  if (!deadlineEOD) {
    if (!paid) return ['Não haverá reembolso pois nenhum pagamento foi feito.'];
    // Deadline desconhecida + pago: sem afirmar reembolso → mensagem neutra
    return ['O pedido de cancelamento será analisado conforme a política do fornecedor/hotel.'];
  }

  if (beforeDeadline) {
    if (!paid) {
      return ['Não haverá reembolso pois nenhum pagamento foi feito.'];
    }
    if (advanceComm) {
      return [
        'O cancelamento foi feito antes do prazo máximo. Será gerado um reembolso do valor pago, abatendo taxa de cancelamento e a comissão que foi antecipada, conforme política.',
        'O reembolso entrará como aguardando processamento. Entre em contato para eventuais dúvidas ou esclarecimentos.',
        'O reembolso da comissão antecipada deverá ser feito pela sua agência para o cliente.'
      ];
    }
    return [
      'O cancelamento foi feito antes do prazo máximo. Será gerado um reembolso do valor pago, abatendo taxa de cancelamento, conforme política.',
      'O reembolso entrará como aguardando processamento. Entre em contato para eventuais dúvidas ou esclarecimentos.'
    ];
  }

  // Depois do prazo
  if (!paid) {
    // não tem pagamento → continua sem reembolso de qualquer forma
    return ['Não haverá reembolso pois nenhum pagamento foi feito.'];
  }
  if (advanceComm) {
    return [
      'O cancelamento foi feito após o prazo máximo. Não haverá reembolso do valor pago, conforme política.',
      'Não haverá devolução da comissão antecipada, a não ser que seja uma opção de sua agência.',
      'Entre em contato para dúvidas ou esclarecimentos.'
    ];
  }
  return [
    <><strong>O cancelamento foi feito após o prazo máximo</strong>. <u>Não haverá reembolso do valor pago</u>, conforme política.</>,
    'Entre em contato para dúvidas ou esclarecimentos.'
  ];
})();

// Para exibir (base + dinâmicas)
const cancelInfoBullets = [...baseBullets, ...dynamicBullets];

// -------------------- Resumo (rótulos p/ UI) --------------------
const displayDeadline =
  reservationData?.booking?.deadlines?.freeCancelDateDisplay ||
  reservationData?.booking?.deadlines?.providerFreeCancelDate?.display ||
  reservationData?.hotel?.rooms?.[0]?.cancelPolicy?.untilDisplay ||
  (deadlineISO ? new Date(deadlineISO).toLocaleDateString('pt-BR') : null);

const summary = {
  deadlineDisplay: displayDeadline || '—',
  timingLabel: deadlineEOD ? (beforeDeadline ? 'antes do prazo' : 'após o prazo') : 'não informado',
  paymentLabel: paid ? 'confirmado' : 'não realizado',
  commissionLabel: advanceComm ? 'antecipada' : reservationData?.commission?.status == 0 ? 'Não há comissão pois não houve pagamento.' : reservationData?.commission?.status == 1 ? 'Comissão gerada. Aguardando pagamento' : 'Comissão gerada e paga',
  methodLabel: reservationData?.latestPayment?.methodLabel || null
};

  /* Activate Success Toast  */
  const showSuccess = (title="",message="") => {
    toast.current.show({severity:'success', summary: title, detail:message, life: 6000});
  }
  
  /* Activate Error Toast  */
  const showError = (title="",message="") => {
    toast.current.show({severity:'error', summary: title, detail:message, life: 6000});
  }
  
  /* Activate Warning Toast  */
  const showWarning = (title="",message="") => {
    toast.current.show({severity:'warn', summary: title, detail:message, life: 6000});
  }

  const resetState = () => {
    setReasonId(null);
    setDescription('');
    setAccepted(false);
    setSubmitting(false);
  };

  const close = () => {
    resetState();
    setCancelDialog(false);
  };

  // Sempre que fechar, limpa campos
  React.useEffect(() => {
    if (!isOpen) resetState();
  }, [isOpen]);


  const handleConfirm = async () => {
  if (!reasonId || !accepted || submitting) return;

  try {
    setSubmitting(true);

    const resp = await cancelReservation({
      bookingId: id,
      cancelReasonId: reasonId,
      cancelReasonDescription: description?.trim()
    });

    // --- Sucesso ---
    if (resp?.success) {

      setAlertTitle('Tudo certo!');
      setAlertBody('A reserva foi cancelada com sucesso. Um email de confirmação de cancelamento foi enviado.');
      setAlert(true);

      close();

      // Recarrega a tela (prioriza callback do pai)
      if (typeof onReloadData === 'function') {
        onReloadData();
        onReloadDataList();
      } else if (typeof executeRetrieveOrder === 'function') {
       // executeRetrieveOrder();
      } else if (typeof retrieveReservation === 'function' && id) {
      //  retrieveReservation({ id });
      }

      return;
    }

    // --- Erro normalizado pelo action ---
    const errKey = String(resp?.errorKey || resp?.details?.errorCode || '');
    const status = resp?.status || null;
    const userMsg =
      resp?.userMessage ||
      'Ocorreu um erro ao cancelar a reserva. Tente novamente.';

    // Se 40901/40902: recarrega dados (status mudou durante o processo)
    if (status === 409 && (errKey === '40901' || errKey === '40902')) {
      
      setAlertTitle('Ops! Temos um problema!');
      setAlertBody(userMsg || 'A reserva mudou de status durante o processo. Atualizamos as informações.');
      setAlert(true);

      close();

      if (typeof onReloadData === 'function') {
        onReloadData();
        onReloadDataList();
      } else if (typeof executeRetrieveOrder === 'function') {
       // executeRetrieveOrder();
      } else if (typeof retrieveReservation === 'function' && id) {
       // retrieveReservation({ id });
      }

      return;
    }

    // Demais erros: exibe mensagem amigável e mantém a modal aberta
    toast?.current?.show({
      severity: 'error',
      summary: 'Erro ao cancelar reserva',
      detail: userMsg,
      life: 10000
    });

  } catch (err) {
    // --- Erro via exceção (rede/timeout/etc.) ---
    const status = err?.response?.status || null;
    const code =
      String(err?.response?.data?.errorCode || err?.response?.data?.code || '');
    const userMsg =
      err?.response?.data?.userMessage ||
      err?.response?.data?.errorMessage ||
      err?.message ||
      'Não foi possível concluir o cancelamento no momento.';

    // Se 40901/40902 mesmo em exceção: recarrega
    if (status === 409 && (code === '40901' || code === '40902')) {

      setAlertTitle('Ops! Temos um problema!');
      setAlertBody(userMsg || 'A reserva mudou de status durante o processo. Atualizamos as informações. Verifique e se for o caso, tente novamente.');
      setAlert(true);
      close();

      if (typeof onReloadData === 'function') {
        onReloadData();
        onReloadDataList();
      } else if (typeof executeRetrieveOrder === 'function') {
        // executeRetrieveOrder();
      } else if (typeof retrieveReservation === 'function' && id) {
        // retrieveReservation({ id });
      }

      return;
    }

    // Outros erros
    console.error('[ReservationCancelModal] cancelReservation error',
      err?.response?.data || err?.message);

    toast?.current?.show({
      severity: 'error',
      summary: 'Erro ao cancelar reserva',
      detail: userMsg,
      life: 10000
    });

  } finally {
    setSubmitting(false);
  }
};


  return (
    <Dialog
      header="Cancelamento de reserva"
      visible={isOpen}
      style={{ width: '760px', maxWidth: '95vw', height:'86vh' }}
      modal
      onHide={() => !submitting && close()}
    >
      <div className="p-fluid" style={{ gap: 12, display: 'flex', flexDirection: 'column' }}>

        <div style={{
        margin: '2px 0',
        padding: '10px',
        background: '#f8f9fa',
        border: '1px solid #eee',
        borderRadius: 8
        }}>
        <p style={{ marginTop: 0 }}>
          Ao cancelar a reserva, aplicam-se as políticas de cancelamento da plataforma Dream4.
        </p>            
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, fontSize: 13 }}>
            <span><strong>Prazo máx. cancelamento:</strong> {summary.deadlineDisplay}</span>
            <span>• <strong>Situação:</strong> {summary.timingLabel}</span>
            <span>• <strong>Pagamento:</strong> {summary.paymentLabel}</span>
            <span>• <strong>Comissão:</strong> {summary.commissionLabel}</span>
            {summary.methodLabel && (
            <span>• <strong>Método:</strong> {summary.methodLabel}</span>
            )}
        </div>
        </div>        

        <div style={{ marginTop: 0, fontSize:"0.85rem" }}>
        <strong>O que ocorrerá ao cancelar</strong>
        <ul style={{ marginTop: 6 }}>
            {cancelInfoBullets.map((msg, idx) => (
            <li key={`cancel-msg-${idx}`}>{msg}</li>
            ))}
        </ul>
        </div>

        <div className="field">
          <label className="p-d-block p-mb-1">Motivo do cancelamento *</label>
          <Dropdown
            value={reasonId}
            options={CANCEL_REASONS}
            placeholder="Selecione..."
            onChange={(e) => setReasonId(e.value)}
            disabled={submitting}
            style={{ width: '50%' }}
          />
        </div>

        <div className="field">
          <label className="p-d-block p-mb-1">
            Descrição (opcional) — {usedChars}/{MAX_DESC}
          </label>
          <InputTextarea
            autoResize
            rows={4}
            value={description}
            maxLength={MAX_DESC}
            onChange={(e) => setDescription(e.target.value)}
            disabled={submitting}
          />
        </div>

        <div className="field-checkbox">
          <Checkbox
            inputId="cancel-accept"
            checked={accepted}
            onChange={(e) => setAccepted(!!e.checked)}
            disabled={submitting}
          />
          <label htmlFor="cancel-accept" style={{ marginLeft: 8 }}>
            Confirmo que desejo prosseguir com o cancelamento desta reserva e estou ciente das condições.
          </label>
        </div>

        <div style={{ display: 'flex', gap: 8, justifyContent: 'space-between', marginTop: 8 }}>
          <Button
            label="Voltar"
            className="p-button-text"
            onClick={close}
            disabled={submitting}
            style={{ maxWidth: "30%"}}
          />
          <Button
            label="Confirmar cancelamento"
            icon={submitting ? 'pi pi-spin pi-spinner' : 'pi pi-check'}
            onClick={handleConfirm}
            disabled={!reasonId || !accepted || submitting}
            style={{ maxWidth: "40%" }}
          />
        </div>
      </div>
      <Toast ref={toast} position="bottom-center" />		
    </Dialog>
  );
};

const mapStateToProps = (store) => ({
  dialog: store.appReducer.dialog,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...AppActions, ...OrderActions }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ReservationCancelModal);
